/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsRdsEngine } from '../models/AwsRdsEngine';
import { AwsRdsResourceAurora } from '../models/AwsRdsResourceAurora';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings';

/**
* Properties of the original AWS RDS instance. Present only when `resourceType` is set to `AWS_RDS`. 
*/
export class AwsRdsResource {
  /**
  * Total database storage size, in bytes.
  */
  'sizeBytes': number;
  /**
  * Database cluster ID.
  */
  'clusterId': string;
  'engine': AwsRdsEngine;
  /**
  * Database engine version.
  */
  'engineVersion': string;
  'storageSettings'?: AwsRdsResourceStorageSettings;
  /**
  * Database name.
  */
  'databaseName': string;
  /**
  * Database instance class.
  */
  'instanceClass': string;
  /**
  * Whether the database is multi-AZ.
  */
  'isMultiAZ': boolean;
  /**
  * Whether the database is publicly accessible.
  */
  'isPubliclyAccessible': boolean;
  /**
  * AWS automated backup retention period in days (1-35 for Aurora, 0-35 for RDS). 0 means automated backups are disabled. For Aurora clusters, this enables Point-In-Time Recovery (PITR). 
  */
  'backupRetentionDays'?: number;
  'aurora'?: AwsRdsResourceAurora | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "clusterId",
      "baseName": "clusterId",
      "type": "string",
      "format": ""
    },
    {
      "name": "engine",
      "baseName": "engine",
      "type": "AwsRdsEngine",
      "format": ""
    },
    {
      "name": "engineVersion",
      "baseName": "engineVersion",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageSettings",
      "baseName": "storageSettings",
      "type": "AwsRdsResourceStorageSettings",
      "format": ""
    },
    {
      "name": "databaseName",
      "baseName": "databaseName",
      "type": "string",
      "format": ""
    },
    {
      "name": "instanceClass",
      "baseName": "instanceClass",
      "type": "string",
      "format": ""
    },
    {
      "name": "isMultiAZ",
      "baseName": "isMultiAZ",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isPubliclyAccessible",
      "baseName": "isPubliclyAccessible",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "aurora",
      "baseName": "aurora",
      "type": "AwsRdsResourceAurora",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsRdsResource.attributeTypeMap;
  }

  public constructor() {
  }
}



